import { render, staticRenderFns } from "./user-add-modal.vue?vue&type=template&id=7a84aaf0&scoped=true&"
import script from "./user-add-modal.vue?vue&type=script&lang=js&"
export * from "./user-add-modal.vue?vue&type=script&lang=js&"
import style0 from "./user-add-modal.vue?vue&type=style&index=0&id=7a84aaf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84aaf0",
  null
  
)

export default component.exports